import React from 'react'
import { styled } from '@mui/material'
import Text from '../atoms/Text'
import Link from '../atoms/Link'

const StyledFooter = styled('div')(() => ({
    backgroundColor: '#201E1E',
    padding: '20px',
    height: '57px',
    '& .content': {
        display: 'flex',
        justifyContent: 'space-between',
        margin: 'auto'
    },
    '& .content .footer-section': {
        display: 'flex',
        alignItems: 'center'
    }
}))

const StyledImg = styled('img')(() => ({
    border: 'none'
}))

const StyledRight = styled('span')(() => ({
    border: 'none'
}))

export default function Footer() {
  return (
    <footer>
        <StyledFooter className="copyright" sx={{height: {xs: '52px', sm: '57px'}}}>
            <div className="content">
                <div className='footer-section'>
                    <StyledImg
                        sx={{height: {xs: '10px', sm: '15px'}, marginRight: {xs: '5px', sm: '10px'}}} 
                        alt='The Northern Miner Group logo'
                        src='/images/TNMG-Logo.png'
                        
                    />
                    <Link 
                        external
                        type='footer'
                        link='https://www.northernminer.com/privacy-policy/'
                        openTab
                        sx={{
                            fontSize: {
                                xs: '0.625rem', sm:'0.875rem'
                            },
                            color: '#FFFFFF',
                            '::after': {
                                content: '"|"',
                                margin: {
                                    xs: '0 2px', sm: '0 5px'
                                }
                            }
                        }}
                    >
                        Policies
                    </Link>
                    <Link 
                        external
                        type='footer'
                        link='https://www.northernminer.com/contact/'
                        openTab
                        sx={{
                            fontSize: {
                                xs: '0.625rem', sm:'0.875rem'
                            },
                            color: '#FFFFFF',
                        }}
                    >
                        Contact
                    </Link>
                </div>
                
                <div className='copy'>
                    <Text sx={{color:'#fff', fontSize: {xs: '0.625rem', sm:'0.875rem'} }} >©2024 TNM GROUP <StyledRight sx={{display: {xs: 'none', sm: 'inline-block'}}}>| All Rights Reserved</StyledRight></Text>
                </div>
            </div>
        </StyledFooter>
    </footer>
  )
}
